/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

export function DisplayConfiguration({
  onChange,
  initialValues,
  errors: externalErrors = {},
}) {
  const [language, setLanguage] = useState("English");
  const [bullets, setBullets] = useState([""]);
  const [syllabus, setSyllabus] = useState([]);

  const [openSubjects, setOpenSubjects] = useState({});
  const [openChapters, setOpenChapters] = useState({});

  useEffect(() => {
    if (!externalErrors?.syllabus) return;
    const openMap = {};
    externalErrors.syllabus.forEach((err, i) => {
      if (err && Object.keys(err).length > 0) openMap[i] = true;
    });
    setOpenSubjects(prev => ({ ...prev, ...openMap }));
  }, [externalErrors?.syllabus]);
  useEffect(() => {
    setLanguage(initialValues?.language || "English");
    setBullets(initialValues?.bullets || [""]);
    setSyllabus(initialValues?.syllabus || []);
  }, [initialValues]);

  const notifyAll = (updated) => {
    onChange?.({
      language,
      bullets,
      syllabus,
      ...updated,
    });
  };

  const updateBullet = (i, val) => {
    const updated = [...bullets];
    updated[i] = val;
    setBullets(updated);
    notifyAll({ bullets: updated });
  };

  const addBullet = () => {
    const updated = [...bullets, ""];
    setBullets(updated);
    notifyAll({ bullets: updated });
  };

  const removeBullet = (i) => {
    const updated = bullets.filter((_, index) => index !== i);
    setBullets(updated);
    notifyAll({ bullets: updated });
  };

  const addSubject = () => {
    const updated = [...syllabus, { subject: "", chapters: [] }];
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const updateSubject = (s, val) => {
    const updated = [...syllabus];
    updated[s].subject = val;
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const removeSubject = (s) => {
    const updated = syllabus.filter((_, i) => i !== s);
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const addChapter = (s) => {
    const updated = [...syllabus];
    updated[s].chapters.push({ chapter: "", topics: [] });
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const updateChapter = (s, c, val) => {
    const updated = [...syllabus];
    updated[s].chapters[c].chapter = val;
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const removeChapter = (s, c) => {
    const updated = [...syllabus];
    updated[s].chapters.splice(c, 1);
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const addTopic = (s, c) => {
    const updated = [...syllabus];
    updated[s].chapters[c].topics.push("");
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const updateTopic = (s, c, t, val) => {
    const updated = [...syllabus];
    updated[s].chapters[c].topics[t] = val;
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  const removeTopic = (s, c, t) => {
    const updated = [...syllabus];
    updated[s].chapters[c].topics.splice(t, 1);
    setSyllabus(updated);
    notifyAll({ syllabus: updated });
  };

  return (
    <div className="mb-6">
      <div className="bg-white rounded-2xl shadow-lg p-10 space-y-10">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800">Display Config</h2>
          <p className="text-sm text-gray-500 mt-1">
            Content shown on the assessment detail page for learners. Switch to Preview Mode to see how this renders.
          </p>
        </div>

        <div className="space-y-3">
          <label className="text-sm font-medium text-gray-700">What You'll Get</label>

          {bullets.map((b, i) => (
            <div key={i}>
              <div className="flex gap-3">
                <input
                  value={b}
                  onChange={(e) => updateBullet(i, e.target.value)}
                  className="flex-1 border rounded-lg p-3"
                />
                <button onClick={() => removeBullet(i)}>✕</button>
              </div>
              {externalErrors?.bullets?.[i] && (
                <p className="text-red-500 text-sm">{externalErrors.bullets[i]}</p>
              )}
            </div>
          ))}

          {externalErrors?.bulletsGeneral && (
            <p className="text-red-500 text-sm mt-1">{externalErrors.bulletsGeneral}</p>
          )}
          <button onClick={addBullet} className="text-blue-600">+ Add item</button>
        </div>

        <div className="space-y-6">
          <h3 className="text-lg font-semibold">Topics Covered</h3>

          {syllabus.map((sub, s) => {
            const subjectErr = externalErrors?.syllabus?.[s] || {};

            return (
              <div key={s} className="border rounded-xl bg-gray-50">

                <div className="flex items-center gap-3 p-4 bg-white border rounded-xl">
                  <button onClick={() =>
                    setOpenSubjects(p => ({ ...p, [s]: !p[s] }))
                  }>▾</button>

                  <input
                    value={sub.subject}
                    onChange={(e) => updateSubject(s, e.target.value)}
                    placeholder="Subject name"
                    className="flex-1 border rounded-lg p-3"
                  />

                  <button onClick={() => removeSubject(s)}>✕</button>
                </div>

                {subjectErr?.subject && (
                  <p className="text-red-500 text-sm px-4">{subjectErr.subject}</p>
                )}
                {subjectErr?.chaptersGeneral && (
                  <p className="text-red-500 text-sm px-4">{subjectErr.chaptersGeneral}</p>
                )}

                {openSubjects[s] && (
                  <div className="p-4 space-y-4">
                    {sub.chapters.map((ch, c) => {
                      const chapterErr = subjectErr?.chapterErrors?.[c] || {};
                      const key = `${s}-${c}`;

                      return (
                        <div key={c} className="ml-6 space-y-2">
                          <div className="flex gap-3 items-center">
                            <input
                              value={ch.chapter}
                              onChange={(e) => updateChapter(s, c, e.target.value)}
                              placeholder="Topic name"
                              className="flex-1 border rounded-lg p-2"
                            />

                            {/* <button
                              className="text-blue-600 border px-3 py-1 rounded"
                              onClick={() =>
                                setOpenChapters(p => ({ ...p, [key]: !p[key] }))
                              }
                            >
                              Topics
                            </button> */}

                            <button onClick={() => removeChapter(s, c)}>✕</button>
                          </div>

                          {chapterErr?.chapter && (
                            <p className="text-red-500 text-xs ml-1">{chapterErr.chapter}</p>
                          )}

                          {openChapters[key] && (
                            <div className="ml-12 space-y-2">
                              {ch.topics.map((t, ti) => (
                                <div key={ti}>
                                  <div className="flex gap-3">
                                    <input
                                      value={t}
                                      onChange={(e) =>
                                        updateTopic(s, c, ti, e.target.value)
                                      }
                                      placeholder="Topic name"
                                      className="flex-1 border rounded-lg p-2"
                                    />
                                    <button onClick={() => removeTopic(s, c, ti)}>✕</button>
                                  </div>
                                  {chapterErr?.topics?.[ti] && (
                                    <p className="text-red-500 text-xs mt-1">{chapterErr.topics[ti]}</p>
                                  )}
                                </div>
                              ))}
                              {/* <button
                                onClick={() => addTopic(s, c)}
                                className="text-blue-600 text-sm"
                              >
                                + Add topic
                              </button> */}
                            </div>
                          )}
                        </div>
                      );
                    })}

                    <button
                      onClick={() => addChapter(s)}
                      className="ml-6 text-blue-600 text-sm"
                    >
                      + Add Topic
                    </button>
                  </div>
                )}
              </div>
            );
          })}

          {externalErrors?.syllabusGeneral && (
            <p className="text-red-500 text-sm mt-1">{externalErrors.syllabusGeneral}</p>
          )}
          <button onClick={addSubject} className="text-blue-600 font-medium">
            + Add subject
          </button>
        </div>
      </div>
    </div>
  );
}

export function SourceBox({ title, data, selected, onToggle }) {
  return (
    <div>
      <div className="font-medium mb-2">{title}</div>
      <div className="border rounded-lg h-48 overflow-y-auto p-3 space-y-2">
        {data?.map((item) => (
          <label key={item?.id} className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={selected?.includes(item?.id)} onChange={() => onToggle(item?.id)} onMouseDown={(e) => e.preventDefault()} className="w-4 h-4 accent-black cursor-pointer" />
            {item?.title}
          </label>
        ))}
      </div>
    </div>
  );
}

export function ChapterBox({ title, data, selected, onToggle }) {
  return (
    <div>
      <div className="font-medium mb-2">{title}</div>
      <div className="border rounded-lg h-48 overflow-y-auto p-3 space-y-2">
        {data?.map((item) => (
          <label key={item?.id} className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={selected?.includes(item?.id)} onChange={() => onToggle(item?.id)} onMouseDown={(e) => e.preventDefault()} className="w-4 h-4 accent-black cursor-pointer" /> {item?.module_name}
          </label>
        ))}
      </div>
    </div>
  );
}
export function createSection(index, isAdaptive) {
  return {
    id: crypto.randomUUID(),
    name: `${isAdaptive ? "Module" : "Section"} ${index}`,
    time: 30,
    sources: [],
    difficulty: "",
    questionperattempt: '',
    questionType: isAdaptive ? "MCQ" : "",
    scoretemplate: ""
  };
}

export function createVariantModule(index) {
  return {
    id: crypto.randomUUID(),
    name: `Variant Module ${index}`,
    time: 30,
    questionperattempt: "",
    questionType: "MCQ",
    difficulties: {
      Easy: {
        sources: []
      },
      Medium: {
        sources: []
      },
      Hard: {
        sources: []
      }
    }
  };
}

export function Preview({previewData,handleDragOver,handleDrop,sectionBreaks,handleDragStart,isAdaptive}) {
  return <div className="bg-indigo-50 rounded-xl border border-indigo-200 p-6">
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-lg font-semibold flex items-center gap-2">Assessment Preview </h2>
    </div>
    <div className="space-y-4">
      {previewData?.sections?.map((sec, idx) => (
        <React.Fragment key={idx}>
          <div className="bg-white border rounded-xl p-4 flex justify-between items-center">
            <div>
              <p className="font-medium">Module {idx + 1}: {sec.name}</p>
              <p className="text-sm text-gray-500">{sec.questionperattempt || 0} questions • {sec.time} min</p>
              {sec.isAdaptive && (<span className="inline-block mt-2 px-2 py-1 text-xs bg-indigo-100 text-indigo-600 rounded">Adaptive Variants</span>)}
            </div>
            {sec.completed && (<span className="text-green-500 text-xl">✓</span>)}
          </div>

         {isAdaptive && <div onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, idx)} className="border-2 border-dashed border-blue-200 rounded-xl p-3 text-center bg-blue-50">
            {sectionBreaks?.[idx] ? (
              <div className="bg-blue-100 p-3 rounded">
                <p className="font-semibold"> {sectionBreaks?.[idx]?.title} </p>
                <p className="text-sm text-gray-600">{sectionBreaks?.[idx]?.message}</p>
              </div>
            ) : (
              <p className="text-sm text-gray-500">Drag Break Screen Here</p>
            )}
          </div>}
        </React.Fragment>
      ))}
    </div>

    <div className="space-y-4 mt-4">
      {previewData?.variant_modules?.map((sec, idx) => (
        <div key={idx} className="bg-white border rounded-xl p-4 flex justify-between items-center">
          <div>
            <p className="font-medium"> Variant Module {idx + 1}: {sec.name}</p>
            <p className="text-sm text-gray-500">{sec.questionperattempt || 0} questions • {sec.time} min</p>
            {sec.isAdaptive && (<span className="inline-block mt-2 px-2 py-1 text-xs bg-indigo-100 text-indigo-600 rounded">Adaptive Variants</span>)}
          </div>
          {sec.completed && (<span className="text-green-500 text-xl">✓</span>)}
        </div>
      ))}
    </div>

    {previewData.breakdetails && (
      <>
        <h3 className="font-semibold mt-8 mb-3">Break Screens</h3>
        {previewData.breakdetails.map((breakItem) => (
          <div key={breakItem.id} draggable onDragStart={(e) => handleDragStart(e, breakItem)} className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-3 cursor-move">
            <p className="font-semibold">{breakItem.title}</p>
            <p className="text-sm text-gray-600">{breakItem.message}</p>
          </div>
        ))}
      </>
    )}
  </div>
}


export function ButtonLabel({assessmentDetail,handleCancel,handleUpdateAssessment,isPublishing,handlePublish}) {
       const { t } = useTranslation();
     return <div className="bg-white border border-gray-200 rounded-lg shadow-sm px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
                <button id="assessment-cancel-btn" onClick={handleCancel} className="px-5 py-2.5 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 self-start sm:self-auto">{t('Cancel')} </button>
                {assessmentDetail ?
                  <div className="flex flex-col sm:flex-row gap-3 sm:ml-auto">
                    <button id="update-assessment-btn" onClick={handleUpdateAssessment} disabled={isPublishing} className={`px-5 py-2.5 rounded-lg text-sm font-medium text-white ${isPublishing ? 'bg-purple-400 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700'} transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 shadow-sm`}>
                      {isPublishing ? (
                        <span className="flex items-center gap-2">
                          <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" >
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                          </svg>Update... </span>
                      ) : (t('Save as Draft'))}
                    </button>
                  </div>
                  :
                  <div className="flex flex-col sm:flex-row gap-3 sm:ml-auto">
                    <button id="publish-assessment-btn" onClick={handlePublish} disabled={isPublishing} className={`px-5 py-2.5 rounded-lg text-sm font-medium text-white ${isPublishing ? 'bg-purple-400 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700'} transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 shadow-sm`}>
                      {isPublishing ? (
                        <span className="flex items-center gap-2">
                          <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" >
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                          </svg>Publishing... </span>
                      ) : (t('Save as Draft'))}
                    </button>
                  </div>}
              </div>
}